import { Alert, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PageHeader } from '../components/PageHeader';
import { redirectToAuth } from '../utilities/redirectToAuth';
import { searchCallback } from '../utilities/searchCallback';
import { detect } from 'detect-browser';

/**
 * @typedef TrackingModuleLayoutProps
 * @property {boolean} hideSearchBar
*/

/** @type {React.FC<TrackingModuleLayoutProps>} */
export const TrackingModuleLayout = (props) => {
    const {
        children,
        hideSearchBar
    } = props;

    const [compatibleBrowser, setCompatibleBrowser] = useState(true);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const browser = detect();
        if (browser?.name === 'ie') {
            setCompatibleBrowser(false);
            setOpen(true);
        }
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <PageHeader
                hideSearchBar={hideSearchBar}
                loginCallback={redirectToAuth}
                searchCallback={searchCallback}
            />
            {!compatibleBrowser && (
                <Snackbar
                    open={open}
                    transitionDuration={{ enter: 0 }}
                >
                    <Alert
                        onClose={handleClose}
                        severity='warning'
                    >
                        Your current browser is unsupported. Please consider updating to a{' '}
                        <a
                            href='https://bestvpn.org/outdatedbrowser/en'
                            rel='noopener noreferrer'
                            target='_blank'
                        >
                            modern browser
                        </a>
                        {' '}for a better experience.
                    </Alert>
                </Snackbar>
            )}
            {children}
        </>
    );
};
